<template>
  <div class="form-card form-card--bare">
    <div class="form-card__body">
      <div class="form-card__field">
        <label class="form-card__label" for="cupon-numero">Número</label>
        <input
          id="cupon-numero"
          v-model="coupon.number"
          type="number"
          class="form-control"
          placeholder="N° de cupón"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cupon-emisor">Nombre del emisor</label>
        <input
          id="cupon-emisor"
          v-model.trim="coupon.name"
          type="text"
          class="form-control"
          placeholder="Nombre del emisor"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cupon-cuit">CUIT</label>
        <input
          id="cupon-cuit"
          v-model="coupon.cuit"
          type="number"
          class="form-control"
          placeholder="CUIT"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cupon-banco">Banco</label>
        <sucursales-bancarias
          id="cupon-banco"
          v-model="coupon.bank_name"
        />
      </div>

      <div class="form-card__field">
        <label class="form-card__label">Cliente</label>
        <typeahead
          :name="'client'"
          :placeh="'Búsqueda de cliente por nombre'"
          :clean-on="false"
          :default="clientname"
          :externalsrc="'/api/clients/getClients'"
          limit-chars="1"
          v-on:choosed="clientUpdate"
          v-on:empty="clientEmpty"
        />
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cupon-monto">Monto</label>
        <input
          id="cupon-monto"
          v-model="coupon.amount"
          type="number"
          step="0.01"
          class="form-control"
          placeholder="Monto"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cupon-fecha-cobro">Fecha de cobro</label>
        <input
          id="cupon-fecha-cobro"
          v-model="coupon.date_due"
          type="date"
          class="form-control"
          required
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cupon-notas">Notas</label>
        <textarea
          id="cupon-notas"
          v-model="coupon.note"
          class="form-control"
          placeholder="Notas..."
          rows="2"
        />
      </div>
    </div>

    <div class="form-card__footer">
      <button v-if="coupon.id != null" type="button" class="form-card__btn" @click="resetForm">
        <i class="bi bi-arrow-clockwise"></i>
        Limpiar
      </button>
      <button type="button" class="form-card__btn form-card__btn--primary" @click="saveCoupons">
        <i class="bi bi-check-lg"></i>
        Guardar cupón
      </button>
    </div>
  </div>
</template>

<script>
import formatDateMixin from "../../mixins/formatDateMixin";
import SucursalesBancarias from "./../sub-components/sucursalesBancarias.vue";
import typeahead from '../global/Typeahead.vue';

export default {
  components: {
    SucursalesBancarias,
    typeahead,
  },
  mixins: [formatDateMixin],
  props: ["couponId"],
  data() {
    return {
      coupon: {
        number: null,
        name: "",
        cuit: null,
        bank_name: "",
        date_due: "",
        client_id: null,
        amount: null,
        note: "",
      },
      emptyCoupon: {
        number: null,
        name: "",
        cuit: null,
        bank_name: "",
        date_due: "",
        client_id: null,
        amount: null,
        note: "",
      },
      clientname: null,
    };
  },
  watch: {
    couponId(value) {
      if (value != null) {
        this.getCoupon(value);
      } else {
        this.resetForm();
      }
    },
  },
  mounted() {
    this.resetForm();
    if (this.couponId != null) {
      this.getCoupon(this.couponId);
    }
  },
  methods: {
    validateForm() {
      if (this.coupon.number === null || isNaN(this.coupon.number)) {
        alert("Debe ingresar un número de cupón");
        return false;
      }
      if (this.coupon.name === null || this.coupon.name === "") {
        alert("Debe ingresar un nombre");
        return false;
      }
      if (this.coupon.cuit === null || isNaN(this.coupon.cuit)) {
        alert("Debe ingresar un nro de CUIT");
        return false;
      }
      if (this.coupon.bank_name == null || this.coupon.bank_name === "") {
        alert("Debe ingresar el nombre del banco");
        return false;
      }
      if (this.coupon.date_due == null || this.coupon.date_due === "") {
        alert("Debe ingresar la fecha de cobro");
        return false;
      }
      if (this.coupon.amount == null || isNaN(this.coupon.amount)) {
        alert("Ingrese el monto a depositar");
        return false;
      }
      return true;
    },
    getCoupon(id) {
      this.$http.get("/api/funds/coupons/get/" + id).then((response) => {
        this.coupon = response.data.data;
        this.coupon.date_issue = this.formatoFecha2Date(this.coupon.date_issue);
        this.coupon.date_due = this.formatoFecha2Date(this.coupon.date_due);
        this.$http.get("/api/clients/getClient/" + this.coupon.client_id).then((res) => {
          this.clientname = res.data.data.name;
        });
      });
    },
    saveCoupons() {
      if (!this.validateForm()) return;
      if (this.coupon.id != null) {
        const data = {
          ...this.coupon,
          date_issue: this.formatoDate2Fecha(this.coupon.date_issue),
          date_due: this.formatoDate2Fecha(this.coupon.date_due),
        };
        this.$http.post("/api/funds/coupons/edit/" + this.coupon.id, data).then(() => {
          this.resetForm();
          this.$emit("confirmsave");
        });
      } else {
        this.$http.post("/api/funds/coupons/add", this.coupon).then(() => {
          this.resetForm();
          this.$emit("confirmsave");
        });
      }
    },
    clientUpdate(data) {
      this.coupon.client_id = data.id;
    },
    clientEmpty() {
      this.coupon.client_id = null;
    },
    resetForm() {
      this.coupon = Object.assign({}, this.emptyCoupon);
      this.clientname = null;
      this.$emit("reset-id");
    },
  },
};
</script>
